module.exports = __webpack_public_path__ + "static/images/destination.2LHhbeO.svg";